import NextImage from 'next/image';
import grispiGif from '../../../public/grispi.gif';
import { IPublicCompanySettings } from '../../hooks/end-user-form/usePublicCompanySettings';

export interface CompanyLogoContainerProps {
    logoSettings: IPublicCompanySettings;
}

const styles = {
    root: { margin: '2rem' },
    imgContainer: {
        width: 225,
        display: 'flex',
        justifyContent: 'center'
    },
    img: {
        maxWidth: '100%',
        display: 'block'
    }
};

const CompanyLogoContainer = ({ logoSettings }: CompanyLogoContainerProps) => {
    return (
        <div style={styles.root}>
            {logoSettings ? (
                <div style={styles.imgContainer}>
                    <img src={logoSettings.value} style={styles.img} alt="Picture of the company" />
                </div>
            ) : (
                <NextImage
                    src={grispiGif}
                    alt="Picture of the company"
                    width={175}
                    height={75}
                    priority
                    layout="fixed"
                />
            )}
        </div>
    );
};

export default CompanyLogoContainer;
